import { graphql } from 'react-relay';

export const ChargeUpdateStatus = graphql`
  mutation ChargeUpdateStatusMutation($input: ChargeUpdateStatusInput!) {
    ChargeUpdateStatus(input: $input) {
      error
      charge {
        id
        ...WooviPayPlugin_charge
        ...Payment_charge
      }
    }
  }
`;
